import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      size: "mini",
      "label-width": "80px"
    }
  }, [_c("div", {
    staticClass: "info"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("字典类型: ")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.typeName))])]), _vm.type === "edit" ? _c("div", {
    staticClass: "item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("引用数: ")]), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.form.n04QuoteNum))])]) : _vm._e()]), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "字典值",
      prop: "n04Value"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入字典值"
    },
    model: {
      value: _vm.form.n04Value,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n04Value", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.n04Value"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 18
    }
  }, [_c("el-form-item", {
    staticClass: "form-item",
    attrs: {
      label: "扩展值",
      prop: "n04ExtValue"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入扩展值"
    },
    model: {
      value: _vm.form.n04ExtValue,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n04ExtValue", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.n04ExtValue"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-item form-item-status",
    attrs: {
      label: "是否有效",
      prop: ""
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66"
    },
    model: {
      value: _vm.form.n04Enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n04Enabled", $$v);
      },
      expression: "form.n04Enabled"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "排序值"
    }
  }, [_c("el-input-number", {
    attrs: {
      step: 1,
      "step-strictly": true,
      min: 0,
      max: 99999,
      label: "越小越靠前"
    },
    model: {
      value: _vm.form.n04Sort,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n04Sort", $$v);
      },
      expression: "form.n04Sort"
    }
  })], 1), _c("el-form-item", {
    staticClass: "dialog-btn-wrap",
    attrs: {
      "label-width": "0"
    }
  }, [_c("el-button", {
    attrs: {
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };